import { render, staticRenderFns } from "./ProfileUser.vue?vue&type=template&id=68468b9c"
import script from "./ProfileUser.vue?vue&type=script&lang=js"
export * from "./ProfileUser.vue?vue&type=script&lang=js"
import style0 from "./ProfileUser.vue?vue&type=style&index=0&id=68468b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports